<template>
  <ul class="date-time-list">
    <li class="date-time-item" v-for="post in posts" v-if="!post.is_master">
      <span class="date-time">
        <span class="date-time-text">{{ displayPublishDate(post) }}</span>
        <i v-if="isDateDuplicate(post)" class="fas fa-exclamation-circle date-duplicate-icon" :id="duplicateDateTooltipId(post)"></i>
        <b-tooltip v-if="isDateDuplicate(post)" :target="duplicateDateTooltipId(post)" triggers="hover">
          This date has multiple posts scheduled
        </b-tooltip>
      </span>
      <SocialStatusLabel :deliverable="post" :today="true" :linkicon="true" />
    </li>
  </ul>
</template>

<script>
import {mapGetters} from "vuex"
import SocialStatusLabel from "./SocialStatusLabel.vue"

export default{
  data() {
    return {
      dateFormat: "ddd, MMM D YYYY @ h:mm a",
      showPastPosts: false,
    }
  },
  props: ['deliverable', 'posts'],
  components: {
    SocialStatusLabel,
  },
  computed: {
    ...mapGetters([
    "systemSettings",
    "userAbilities",
    ]),
  },
  methods: {
    displayPublishDate(post){
      if(post){
        //let date = this.$moment.utc(seriesPost.publish_date).local().format("MMMM Do YYYY, h:mm a");
        let date = this.$moment.utc(post.publish_date).local().format(this.dateFormat);
        if(date == "Invalid date"){
          return "No date set";
        }
        return date;
      }
    },
    isDateDuplicate(currentPost){
      let isDuplicate = false;
      if(this.posts){
        let that = this;
        let publishDate = this.$moment.utc(currentPost.publish_date).local();
        for(let post of this.posts){
          if(currentPost.id == post.id){
            continue;
          } else if(post.publish_date == null){
            continue;
          }
          let seriesPublishDate = that.$moment.utc(post.publish_date).local();
          if(publishDate.isSame(seriesPublishDate, 'day')){
            isDuplicate = true;
          }
        }
      }
      return isDuplicate;
    },
    duplicateDateTooltipId(post){
      return "summary-duplicate-date-"+post.id;
    }
  }
}
</script>